module.exports = __webpack_public_path__ + "media/images/recipes/my_recipe_btn-3c037de5918d55f1c580a47ee796f612.png";